import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import {
  DELETE_KEY_MAPPINGS_PERMISSION,
  GET_KEY_MAPPINGS_PERMISSION,
} from '../../redux/actions/actionTypes'
import * as keyMappingActions from '../../redux/actions/keyMappingActions'
import { store, useAppDispatch } from '../../redux/configureStore'
import { IRootState } from '../../redux/reducers'
import {
  DeviceKeyMappingInfo,
  DeviceKeyMappingsState,
} from '../../redux/reducers/initialState'
import { usePermissions } from '../common/permission/usePermissions'

import KeyMappingsList from './KeyMappingsList'

export default function KeyMappingsPage() {
  const searchMappingRequestStore: DeviceKeyMappingInfo = useSelector(
    (state: IRootState) => state.searchMappingRequest,
  )
  const keyMappings: DeviceKeyMappingsState = useSelector(
    (state: IRootState) => state.keyMappings,
  )
  const loading: boolean = useSelector(
    (state: IRootState) => state.apiCallsInProgress > 0,
  )

  const [searchMappingRequest, setSearchMappingRequest] = useState(
    searchMappingRequestStore,
  )
  const [keyMappingsExists, setKeyMappingsExists] = useState(true)
  const firstUpdate = useRef(true)
  const dispatch = useAppDispatch()
  const { checkPermissions } = usePermissions()

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false
      return
    }

    setKeyMappingsExists(keyMappings.deviceKeyMappings.length > 0)

    if (
      //dispatch(addKeyMappingSuccess()): A state mutation was detected between dispatches, in the path `searchMappingRequest.continuationToken`. This may cause incorrect behavior.
      (keyMappings.continuationToken != null &&
        Object.keys(keyMappings.continuationToken).length != 0) ||
      (searchMappingRequest.continuationToken != null &&
        searchMappingRequest.continuationToken.length != 0)
    ) {
      searchMappingRequest.continuationToken = keyMappings.continuationToken
    }

    setSearchMappingRequest(searchMappingRequest)
  }, [keyMappings.deviceKeyMappings])

  const handleDeleteKey = (keyMapping) => {
    checkPermissions(store.getState(), DELETE_KEY_MAPPINGS_PERMISSION)
    dispatch(keyMappingActions.deleteKeyMapping(keyMapping))
  }

  const handleSearch = () => {
    checkPermissions(store.getState(), GET_KEY_MAPPINGS_PERMISSION)
    dispatch(keyMappingActions.loadKeyMappings(searchMappingRequest))
  }

  const handleLoadMore = () => {
    checkPermissions(store.getState(), GET_KEY_MAPPINGS_PERMISSION)
    dispatch(keyMappingActions.loadMoreKeyMappings(searchMappingRequest))
  }

  const handleChange = (event) => {
    setSearchCriteria(event.target.name, event.target.value)
  }

  const handleBlur = (event) => {
    setSearchCriteria(event.target.name, event.target.value.trim())
  }

  const setSearchCriteria = (name, value) => {
    const newSearchMappingRequest = {
      ...searchMappingRequest,
      [name]: value,
    }
    setSearchMappingRequest(newSearchMappingRequest)
  }

  return (
    <div className="container responsive-font">
      <h3 className="page-header">Manage Permissions</h3>
      <KeyMappingsList
        keyMappings={keyMappings.deviceKeyMappings}
        loading={loading}
        onSearchClick={handleSearch}
        onDeleteClick={handleDeleteKey}
        onLoadMoreClick={handleLoadMore}
        handleChange={handleChange}
        handleBlur={handleBlur}
        keyMappingsExists={keyMappingsExists}
        searchMappingsRequest={searchMappingRequest}
      />
    </div>
  )
}
